import { render, staticRenderFns } from "./ModalBroadcastMessageDescription.vue?vue&type=template&id=647c0f2a&scoped=true"
import script from "./ModalBroadcastMessageDescription.vue?vue&type=script&lang=js"
export * from "./ModalBroadcastMessageDescription.vue?vue&type=script&lang=js"
import style0 from "./ModalBroadcastMessageDescription.vue?vue&type=style&index=0&id=647c0f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c0f2a",
  null
  
)

export default component.exports